export default "/_next/static/chunks/fonts/Channel4Horseferry-ExtraBoldItalic-9fee4486a4bc6f2c9bf60ee4ee0f1c36.woff2";